import type { Components } from '@mui/material/styles/components';

export const MuiSwitch: Components['MuiSwitch'] = {
  styleOverrides: {
    root: () => ({
      padding: 0,
      height: '20px',
      width: '40px',
      '& + .MuiFormControlLabel-label': {
        fontWeight: 500,
      },
      '&.Mui-checked .MuiSwitch-track': {
        backgroundColor: '#6948EB',
      },
    }),
    switchBase: () => ({
      padding: '2px',
    }),
    track: () => ({
      padding: '2px',
      backgroundColor: '#D4DFF9',
      opacity: '1 !important',
      borderRadius: '12px',
      height: '20px',
    }),
    thumb: () => ({
      color: '#FFFFFF',
      width: '16px',
      height: '16px',
    }),
  },
};
